import { Component, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'layout-ai-edit-button',
  templateUrl: './layout-ai-edit-button.component.html',
  styleUrls: ['./layout-ai-edit-button.component.scss'],
  imports: [MatButtonModule, MatIconModule],
})
export class LayoutAiEditButtonComponent {
  readonly edit = output<void>();
}
